/**
 * Random coupon code (6 random bytes as uppercase hex) for the admin UI.
 */
export const generateCouponCode = (): string => {
  const bytes = new Uint8Array(6);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'))
    .join('')
    .toUpperCase();
};
